<body>
        <app-head-carousel></app-head-carousel>
    <div class="container">
        <app-product></app-product>
    </div>
</body>